export const getServiceCategories = async () => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      `/api/content/services/getCategories`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const bookmarkMyService = async (id) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      `/api/content/services/bookmark/${id}`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getServices = async (categoryType) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      `/api/content/services/getServices?type=${categoryType}`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getNews = async ({ page = 1, pageSize = 10 }) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      `/api/content/news?page=${page}&pageSize=${pageSize}`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getNewDetail = async ({ newID }) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(`/api/content/news/${newID}`, requestOptions);
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getFAQCategories = async () => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(`/api/content/faqCategory`, requestOptions);
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getFAQ = async ({ faqID }) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(`/api/content/faq/${faqID}`, requestOptions);
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getCircular = async ({
  page = 1,
  pageSize = 10,
  language = "en",
}) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
        "language": language
      },
    };
    const response = await fetch(
      `/api/hasana/circulars/listOfCirculars?page=${page}&pageSize=${pageSize}`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getCircularDetails = async ({
  ref,
  language = "en",
}) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
        "language": language
      },
    };
    const response = await fetch(
      `/api/hasana/circulars/detailOfCirculars?ref=${ref}`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getStaticCategory = async ({
  url = "",
  page = 1,
  pageSize = 10,
}) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(`${url}`, requestOptions);
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getRegulatoryDocsCategory = async ({
  page = 1,
  pageSize = 10,
}) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      `/api/content/regulatoryDocumentCategory?page=${page}&pageSize=${pageSize}`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getRegulatoryDocs = async ({ cateID }) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      `/api/content/regulatoryDocument/${cateID}`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getPromotionAwarenessCategory = async ({
  page = 1,
  pageSize = 10,
}) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      `/api/content/promotionAwarenessCategory?page=${page}&pageSize=${pageSize}`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getPromotionAwareness = async ({
  page = 1,
  pageSize = 10,
  cateID = "",
}) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      `/api/content/promotionAwareness/${cateID}`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getHome = async () => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(`/api/content/home`, requestOptions);
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const searchAPI = async ({ query = "" }) => {
  try {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      `/api/content/search?query=${query}`,
      requestOptions,
    );
    const json = await response.json();
    return json;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const submitFeedback = async ({
  wasHelpful = "",
  name = "",
  email = "",
  phoneNumber = "",
  comment = "",
  pageUrl = "",
}) => {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        wasHelpful,
        name,
        email,
        phoneNumber,
        comment,
        pageUrl,
      }),
    };

    const response = await fetch(`/api/content/feedbacks`, requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};

export const getAllRegulatoryDocuments = async () => {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await fetch(
      `/api/content/regulatoryDocuments`,
      requestOptions,
    );
    const response2 = await response.json();
    console.log("response2", response2);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response2;
  } catch (e) {
    console.error("API Error", e);
    throw e;
  }
};
